(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["takumi-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-takumi-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-takumi-collection]').forEach((section) => {
    const filters = section.querySelector('[data-takumi-tech-filters]');
    if (!filters) return;

    const search = filters.querySelector('[data-tech-search]');
    const availability = filters.querySelector('[data-tech-availability]');
    const price = filters.querySelector('[data-tech-price-filter]');
    const grid = section.querySelector('.takumi-collection__grid');
    const pagination = section.querySelector('.takumi-collection__pagination');
    const cards = [...section.querySelectorAll('[data-tech-card]')];
    const count = section.querySelector('[data-takumi-visible-count]');
    const initialCount = count ? count.textContent : String(cards.length);
    const empty = section.querySelector('[data-tech-empty]');
    const clearButtons = section.querySelectorAll('[data-tech-clear]');
    let allCardsPromise;
    let debounceTimer;

    const normalize = (value) => value
      .toLocaleLowerCase('es')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    const matchesPrice = (amount, selectedRange) => {
      if (selectedRange === 'under-10') return amount < 1000;
      if (selectedRange === '10-25') return amount >= 1000 && amount < 2500;
      if (selectedRange === '25-50') return amount >= 2500 && amount < 5000;
      if (selectedRange === '50-plus') return amount >= 5000;
      return true;
    };

    const hasActiveFilters = () => search.value.trim() !== '' || availability.value !== 'all' || price.value !== 'all';

    const updateUrl = () => {
      const url = new URL(window.location.href);
      const values = {
        tech_q: search.value.trim(),
        tech_stock: availability.value === 'all' ? '' : availability.value,
        tech_price: price.value === 'all' ? '' : price.value
      };

      Object.entries(values).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });

      if (hasActiveFilters()) url.searchParams.delete('page');

      window.history.replaceState({}, '', url.toString());
    };

    const loadAllCards = () => {
      if (allCardsPromise || !grid || !pagination) return allCardsPromise || Promise.resolve();

      const pageNumbers = [...pagination.querySelectorAll('a[href]')]
        .map((link) => Number(new URL(link.href, window.location.href).searchParams.get('page') || 1))
        .filter((pageNumber) => Number.isFinite(pageNumber));
      const lastPage = Math.max(1, ...pageNumbers);
      const currentPage = Number(new URL(window.location.href).searchParams.get('page') || 1);

      allCardsPromise = Promise.all(
        Array.from({ length: lastPage }, (_, index) => index + 1)
          .filter((pageNumber) => pageNumber !== currentPage)
          .map(async (pageNumber) => {
            const url = new URL(window.location.href);
            url.searchParams.set('page', String(pageNumber));
            url.searchParams.delete('tech_q');
            url.searchParams.delete('tech_stock');
            url.searchParams.delete('tech_price');

            const response = await fetch(url.toString(), { credentials: 'same-origin' });
            if (!response.ok) return [];

            const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
            return [...documentFragment.querySelectorAll('[data-tech-card]')];
          })
      ).then((pages) => {
        pages.flat().forEach((card) => {
          card.dataset.techLoaded = 'true';
          grid.appendChild(card);
          cards.push(card);
        });
      });

      return allCardsPromise;
    };

    const restoreDefault = () => {
      cards.forEach((card) => {
        card.hidden = card.dataset.techLoaded === 'true';
      });
      if (count) count.textContent = initialCount;
      if (empty) empty.hidden = true;
      if (pagination) pagination.hidden = false;
    };

    const applyFilters = async () => {
      updateUrl();

      if (!hasActiveFilters()) {
        restoreDefault();
        return;
      }

      if (count) count.textContent = '…';
      await loadAllCards();

      const query = normalize(search.value);
      const stock = availability.value;
      const selectedPrice = price.value;
      let visible = 0;

      cards.forEach((card) => {
        const searchableText = normalize(card.dataset.techSearchText || '');
        const isAvailable = card.dataset.techAvailable === 'true';
        const amount = Number(card.dataset.techPrice || 0);
        const matchesQuery = !query || searchableText.includes(query);
        const matchesStock = stock === 'all' || (stock === 'available' && isAvailable) || (stock === 'sold-out' && !isAvailable);
        const shouldShow = matchesQuery && matchesStock && matchesPrice(amount, selectedPrice);

        card.hidden = !shouldShow;
        if (shouldShow) visible += 1;
      });

      if (count) count.textContent = String(visible);
      if (empty) empty.hidden = visible !== 0;
      if (pagination) pagination.hidden = true;
    };

    const scheduleFilters = () => {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(applyFilters, 180);
    };

    const currentUrl = new URL(window.location.href);
    search.value = currentUrl.searchParams.get('tech_q') || '';
    availability.value = currentUrl.searchParams.get('tech_stock') || 'all';
    price.value = currentUrl.searchParams.get('tech_price') || 'all';

    [search, availability, price].forEach((control) => {
      control.addEventListener('input', scheduleFilters);
      control.addEventListener('change', scheduleFilters);
    });

    clearButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const form = button.closest('form');
        if (!form) return;
        event.preventDefault();
        window.location.assign(form.action);
      });
    });

    if (hasActiveFilters()) applyFilters();
    else restoreDefault();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["takumi-header"]) return;
  try {
    
  (() => {
    const headers = document.querySelectorAll('.takumi-header');
    headers.forEach((header) => {
      const toggle = header.querySelector('.takumi-header__toggle');
      const menu = header.querySelector('.takumi-header__mobile');
      if (!toggle || !menu) return;
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        toggle.setAttribute('aria-label', open ? 'Abrir menú' : 'Cerrar menú');
        menu.hidden = open;
      });
    });

    const dropdowns = document.querySelectorAll('.takumi-header__dropdown');
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => {
        if (!dropdown.open) return;
        dropdowns.forEach((other) => {
          if (other !== dropdown) other.removeAttribute('open');
        });
      });
    });

    document.addEventListener('click', (event) => {
      dropdowns.forEach((dropdown) => {
        if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      dropdowns.forEach((dropdown) => {
        if (!dropdown.open) return;
        dropdown.removeAttribute('open');
        dropdown.querySelector('summary')?.focus();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["takumi-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const products = document.querySelectorAll('[data-takumi-product]');
    products.forEach((product) => {
      const variantsNode = product.querySelector('[data-product-variants]');
      const variantId = product.querySelector('[data-variant-id]');
      const price = product.querySelector('[data-product-price]');
      const addButton = product.querySelector('[data-add-button]');
      const addLabel = product.querySelector('[data-add-label]');
      const fileInput = product.querySelector('[data-file-input]');
      const fileLabel = product.querySelector('[data-file-label]');
      if (!variantsNode || !variantId || !addButton || !addLabel) return;

      const variants = JSON.parse(variantsNode.textContent);
      const availableLabel = addButton.dataset.availableLabel;
      const soldOutLabel = addButton.dataset.soldOutLabel;

      const updateVariant = () => {
        const selected = Array.from(product.querySelectorAll('.takumi-product-option')).map((group) => {
          return group.querySelector('.takumi-product-option__input:checked')?.value;
        });
        const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
        if (!variant) {
          addButton.disabled = true;
          return;
        }
        variantId.value = variant.id;
        if (price) price.textContent = variant.price;
        addButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? availableLabel : soldOutLabel;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      product.querySelectorAll('.takumi-product-option__input').forEach((input) => input.addEventListener('change', updateVariant));

      if (fileInput && fileLabel) {
        fileInput.addEventListener('change', () => {
          if (fileInput.files.length > 0) fileLabel.textContent = fileInput.files[0].name;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
